import { render, staticRenderFns } from "./HeroCarousel.vue?vue&type=template&id=85ab70c6&scoped=true"
import script from "./HeroCarousel.vue?vue&type=script&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&lang=js"
import style0 from "./HeroCarousel.vue?vue&type=style&index=0&id=85ab70c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ab70c6",
  null
  
)

export default component.exports